import React, { lazy, Suspense, useEffect } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import { AuthRoute, GuestRoute, ProtectedRoute } from 'components/Auth';
import { ResponsiveDrawer, Error404, LoadingScreen } from 'components'
import gtm from 'utils/googleAnalytics';

export default function Routes() {
  const Login = lazy(() => import('pages/Login'));
  const LandingPage = lazy(() => import('pages/LandingPage'));
  const Momentum = lazy(() => import('pages/Momentum'));
  const Welcome = lazy(() => import('pages/Welcome'));
  const Blog = lazy(() => import('pages/Blog'));
  const Post = lazy(() => import('pages/Blog/Post'));
  const ForgotPassword = lazy(() => import('pages/ForgotPassword'))
  const NewPassword = lazy(() => import('pages/ForgotPassword/NewPassword'))
  const Profile = lazy(() => import('pages/Profile'))
  const UseTerms = lazy(() => import('pages/UseTerms'))
  const CloseFriends = lazy(() => import('pages/CloseFriends'))
  const AddCloseFriends = lazy(() => import('pages/AddCloseFriends'))
  const Utilities = lazy(() => import('pages/Utilities'))
  const QuantitativeStrategies = lazy(() => import('pages/LandingPage/QuantitativeStrategies'))
  const MixStrategies = lazy(() => import('pages/MixStrategies'))
  const ManualPage = lazy(() => import('pages/ManualPage'))

  useEffect(() => {
    gtm.initialize('G-DXXF86J5D9');
  }, []);

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        <Route exact path='/404' component={Error404} />
        <GuestRoute exact path='/home' component={LandingPage} />
        <GuestRoute exact path="/home/estrategias-quantitativas" component={QuantitativeStrategies} />
        <GuestRoute exact path='/close-friends' component={CloseFriends} />
        <GuestRoute exact path='/login' component={Login} />
        <GuestRoute exact path='/adicionar-close-friends' component={AddCloseFriends} />
        <GuestRoute exact path='/esqueci-minha-senha' component={ForgotPassword} />
        <GuestRoute exact path='/nova-senha' component={NewPassword} />
        <GuestRoute exact path='/termos-de-uso' component={UseTerms} />
        <AuthRoute
          path='/'
          render={(props) => (
            <ResponsiveDrawer {...props}>
              <Suspense fallback={<LoadingScreen />}>
                <Switch>
                  <Redirect exact from='/' to='/welcome' />
                  <ProtectedRoute exact path='/welcome' component={Welcome} />
                  <ProtectedRoute exact path='/blog' component={Blog} />
                  <ProtectedRoute exact path='/estrategias' component={Momentum} />
                  <ProtectedRoute exact path='/estrategias-mix' component={MixStrategies} />
                  <Route exact path='/utilidades' component={Utilities} />
                  <Route path='/post/:id' component={Post} />
                  <Route exact path='/perfil' component={Profile} />
                  <Route exact path='/manual' component={ManualPage} />
                  <Redirect to='/404' />
                </Switch>
              </Suspense>
            </ResponsiveDrawer>
          )}
        />
      </Switch>
    </Suspense>
  );
}